import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useStore } from '@/models';
import { syncZendeskWidget } from '@/config/zendesk';

const BaseInfoRequester: React.FC = () => {
  const { coin, account } = useStore();

  const { fetchAssistPriceMap, userInfo, isLogin, lang } = account;

  const { fetchSymbolList, fetchPairSets, fetchPairAll, fetchCoinsConfig } = coin;
  useEffect(() => {
    fetchSymbolList();
    fetchPairSets();
    fetchAssistPriceMap();
    fetchCoinsConfig();
    fetchPairAll();
  }, []);

  // Existing conversations follow login/logout and locale changes. The SDK is
  // loaded by an explicit customer-service click, not by the trading hot path.
  useEffect(() => {
    syncZendeskWidget(isLogin && userInfo?.id ? userInfo : null, lang);
  }, [isLogin, userInfo?.id, lang]);

  return <></>;
};

export default observer(BaseInfoRequester);
